export const SuccessIcon = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="10" cy="10" r="9.5" stroke="white" />
      <path d="M14 7L8.07407 13L6 10.9" stroke="white" />
    </svg>
  );
};
